import { render } from "./InviteDetails.vue?vue&type=template&id=2ce2c64b&scoped=true"
import script from "./InviteDetails.vue?vue&type=script&lang=js"
export * from "./InviteDetails.vue?vue&type=script&lang=js"

import "./InviteDetails.vue?vue&type=style&index=0&id=2ce2c64b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ce2c64b"]])

export default __exports__